<template>
  <!-- NOTE (TEMPLATE) to show the specific proposal page -->

  <div>
    <!-- loading component -->
    <Loading />
    <MeetingCp role="admin" />
  </div>
</template>

<script>
const MeetingCp = () => import("../../components/MeetingCp");

export default {
  components: {
    MeetingCp // NOTE (c-proposal) component of proposal
  },
  data() {
    return {};
  },

  methods: {}
};
// REVIEW mounted
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped>
.color {
  background-color: #0c4961;
  color: white;
}
</style>
